<template>
  <v-container>
    <v-row>
      <v-col v-for="(item, i) in itemsRefCard" :key="i" cols="4">
        <v-card outlined min-height="220" v-if="
          !router_path_filtro ||
          (router_path_filtro && router_path_filtro == item.original_estado)
        ">
          <v-card-text class="text-center">
            <v-icon size="52" class="mt-2"> mdi-file-document-outline</v-icon>
            <p class="text--primary font-weight-regular text-h6">
              {{ item.title }}
            </p>
          </v-card-text>
          <v-card-text>
            <v-row justify="center" class="mt-n7" no-gutters>
              <v-col cols="12" md="12" xl="12" class="mb-2">
                <v-select clearable :disabled="item.estado == 'Rechazado' || flag_gestion_terminada"
                  v-model="item.estado" :items="itemsEstado" label="Estado" rounded single-line dense
                  append-icon="mdi-chevron-down" class="px-1" @change="fnActualizarEstadoComplemento(item, i)">
                </v-select>
              </v-col>
              <v-col cols="12">
                <div class="px-2 mb-2 mt-n5">
                  <table>
                    <tr>
                      <td class="text--secondary font-weight-bold text-body-2">
                        Nombre
                      </td>
                      <td class="text--secondary font-weight-regular text-body-2" align="right">
                        {{ item.nombre }}
                      </td>
                    </tr>

                    <tr>
                      <td class="text--secondary font-weight-bold text-body-2">
                        Teléfono
                      </td>
                      <td class="text--secondary font-weight-regular text-body-2" align="right">
                        {{ item.telefono }}
                      </td>
                    </tr>

                    <tr v-if="i != 0">
                      <td class="text--secondary font-weight-bold text-body-2">
                        Parentesco
                      </td>
                      <td class="text--secondary font-weight-regular text-body-2" align="right">
                        {{ item.parentesco }}
                      </td>
                    </tr>
                  </table>
                </div>
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions v-if="item.ultima_actualizacion_usuario">
            <v-row no-gutters>
              <v-col>
                <span class="font-weight-regular text-caption">Ultima modificacion: {{
                  fnGetDate(item.ultima_actualizacion_fecha) }}<br>
                  Por: {{ item.ultima_actualizacion_usuario }}</span>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <!-- /** */ -->
    <v-dialog v-model="modalComplementoRechazado" max-width="500" persistent>
      <v-card v-if="modalComplementoRechazadoData">
        <v-card-title class="headline">Rechazar complemento</v-card-title>
        <v-card-text>
          <p>
            ¿Está seguro de que desea rechazar el complemento
            <strong>{{
              modalComplementoRechazadoData.complemento_nombre
            }}</strong>?
          </p>
          <small><strong>Advertencia</strong></small>
          <p>
            *. Se enviará una notificación a la supervisora de que se ha enviado
            un complemento para rectificación.
          </p>
          <p>
            *. Esta rectificación desaparecerá hasta que sea corregida por la
            supervisora.
          </p>
          <v-text-field ref="motivorechazocomentario" v-model="comentario" label="Motivo del rechazo" required
            :rules="[rules.required]"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" dark @click="rechazarComplemento(modalComplementoRechazadoData)"
            :disabled="!comentarioValido || bloquear">Sí, enviar a rectificación</v-btn>
          <v-progress-circular v-if="bloquear" class="mr-2" title="Estableciendo conexión con el servidor en Guatemala"
            indeterminate color="primary"></v-progress-circular>
          <v-btn :disabled="bloquear" color="grey" @click="cancelar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /** */ -->
    <v-dialog v-model="modalComplementoPendiente" max-width="500" persistent>
      <v-card v-if="modalComplementoPendienteData">
        <v-card-title class="headline">Marcar como pendiente</v-card-title>
        <v-card-text>
          <p>
            ¿Está seguro de que desea marcar como pendiente el complemento
            <strong>{{
              modalComplementoPendienteData.complemento_nombre
            }}</strong>?
          </p>
          <small><strong>Advertencia</strong></small>
          <p>
            *. Se enviará una notificación a la supervisora de que se ha enviado
            un complemento como pendiente.
          </p>

          <v-text-field ref="motivorechazocomentario" v-model="comentario" label="Comentario obligatorio:" required
            :rules="[rules.required]"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="spacer" dark @click="pendienteComplemento(modalComplementoPendienteData)"
            :disabled="!comentarioValido || bloquear">Sí, marcar como pendiente</v-btn>
          <v-progress-circular v-if="bloquear" class="mr-2" title="Estableciendo conexión con el servidor en Guatemala"
            indeterminate color="primary"></v-progress-circular>
          <v-btn :disabled="bloquear" color="grey" @click="cancelar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /** */ -->
    <v-dialog v-model="modalComplementoAprobado" max-width="500" persistent>
      <v-card v-if="modalComplementoAprobadoData">
        <v-card-title class="headline">Marcar como aprobado</v-card-title>
        <v-card-text>
          <p>
            ¿Está seguro de que desea marcar como aprobado el complemento
            <strong>{{
              modalComplementoAprobadoData.complemento_nombre
            }}</strong>?
          </p>


          <v-text-field ref="motivorechazocomentario" v-model="comentario" label="Comentario obligatorio:" required
            :rules="[rules.required]"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="spacer" dark @click="aprobadoComplemento(modalComplementoAprobadoData)"
            :disabled="!comentarioValido || bloquear" :loading="bloquear" class="mr-2">
            {{ bloquear ? 'Procesando...' : 'Sí, marcar como aprobado' }}
            <template v-if="bloquear">
              <v-progress-circular indeterminate size="20" width="2" class="ml-2"></v-progress-circular>
            </template>
          </v-btn>

          <v-btn :disabled="bloquear" color="grey" @click="cancelar">Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /** */ -->
    <v-snackbar v-model="snackbar" timeout="3500" color="success" right top class="mt-14">
      <v-row>
        <v-col cols="1" md="1">
          <v-icon>mdi-check-circle</v-icon>
        </v-col>
        <v-col cols="11" md="11">
          <div class="text-center">
            <p class="text-subtitle-2 font-weight-medium white--text">
              Estado de complemento actualizado
            </p>
          </div>
        </v-col>
      </v-row>
      <!-- /**LOADING BAR */ -->
    </v-snackbar>
  </v-container>
</template>

<script>
import { EventBus } from '../event-bus.js';
import { mapActions } from 'vuex';
import moment from 'moment';
require('moment/locale/es.js');
export default {
  name: 'vistaReferencias',
  props: ['detalleEvaluacion'],
  data() {
    return {
      bloquear: false,
      snackbar: false,
      // por pendiente de complemento
      modalComplementoPendiente: false,
      modalComplementoPendienteData: null,
      modalComplementoPendienteIndex: null,
      /**por rechazo de complemento */
      modalComplementoRechazado: false,
      modalComplementoRechazadoData: null,
      modalComplementoRechazadoIndex: null,
      /**por aprobado de complemento */
      modalComplementoAprobado: false,
      modalComplementoAprobadoData: null,
      modalComplementoAprobadoIndex: null,
      //
      comentario: '',
      rules: {
        required: (v) => !!v || 'El comentario es requerido',
      },
      //
      referencia: null,
      still_loading: true,
      //items temporales con la información para las cards del apartado de REFERENCIAS
      itemsRefCard: [
        {
          id: null,
          API: 'patchReferencias',
          tbl_attribute: 'estado',
          tbl_comentario_attribute: 'comentario_de_aprobacion',
          complemento_nombre: 'Titular',
          title: 'Titular',
          nombre: '',
          telefono: '',
          estado: null,
          original_estado: null,
          ultima_actualizacion_fecha: null,
          ultima_actualizacion_usuario: null
        },
        {
          id: null,
          API: 'patchReferencias',
          tbl_attribute: 'estado',
          tbl_comentario_attribute: 'comentario_de_aprobacion',
          complemento_nombre: 'Familiar #1',
          title: 'Familiar #1',
          nombre: '',
          telefono: '',
          parentesco: '',
          estado: null,
          original_estado: null,
          ultima_actualizacion_fecha: null,
          ultima_actualizacion_usuario: null
        },
        {
          id: null,
          API: 'patchReferencias',
          tbl_attribute: 'estado',
          tbl_comentario_attribute: 'comentario_de_aprobacion',
          complemento_nombre: 'Familiar #2',
          title: 'Familiar #2',
          nombre: '',
          telefono: '',
          parentesco: '',
          estado: null,
          original_estado: null,
          ultima_actualizacion_fecha: null,
          ultima_actualizacion_usuario: null
        },
        {
          id: null,
          API: 'patchReferencias',
          tbl_attribute: 'estado',
          tbl_comentario_attribute: 'comentario_de_aprobacion',
          complemento_nombre: 'Personal #1',
          title: 'Personal #1',
          nombre: '',
          telefono: '',
          parentesco: '',
          estado: null,
          original_estado: null,
          ultima_actualizacion_fecha: null,
          ultima_actualizacion_usuario: null
        },
        {
          id: null,
          API: 'patchReferencias',
          tbl_attribute: 'estado',
          tbl_comentario_attribute: 'comentario_de_aprobacion',
          complemento_nombre: 'Personal #2',
          title: 'Personal #2',
          nombre: '',
          telefono: '',
          parentesco: '',
          estado: null,
          original_estado: null,
          ultima_actualizacion_fecha: null,
          ultima_actualizacion_usuario: null
        },
      ],

      estado: null, //para almacenar el estado que tiene
      //items para mostrar cuando se da clic en el menú estado
      itemsEstado: ['Aprobado', 'Rechazado', 'Pendiente'],
    };
  },
  methods: {
    ...mapActions('RevisionRechazarReferencia', {
      createRevisionRechazarReferencia: 'create'
    }),
    ...mapActions('PendientesAprobarReferencias', {
      createPendientesAprobarReferencias: 'create'
    }),
    ...mapActions(process.env.VUE_APP_PRODUCCION_API_REFERENCIAS, {
      createReferencias: 'create',
      getReferencias: 'get',
      patchReferencias: 'patch',
    }),
    ...mapActions(process.env.VUE_APP_PRODUCCION_API_RECTIFICACIONES, {
      createRectificaciones: 'create',
      getRectificaciones: 'get',
      patchRectificaciones: 'patch',
    }),
    ...mapActions(process.env.VUE_APP_PRODUCCION_API_PENDIENTES, {
      findPendientes: 'find',
      createPendientes: 'create',
      getPendientes: 'get',
      patchPendientes: 'patch',
    }),
    //
    fnGetDate(date) {
      return date ? moment(date).format('DD-MM-YYYY HH:mm a') : '';
    },
    /*** */
    async aprobadoComplemento(complemento) {
      if (this.bloquear) return; // Prevent multiple clicks while processing

      this.bloquear = true;

      try {
        // Create a promise to track the server update
        const updateResult = await this.createPendientesAprobarReferencias({
          complemento: {
            ...complemento,
            original_estado: complemento.original_estado,
            estado: complemento.estado,
            tbl_attribute: complemento.tbl_attribute,
            tbl_comentario_attribute: complemento.tbl_comentario_attribute
          },
          currentUser: this.currentUser,
          comentario: this.comentario
        });

        // Only proceed if the server update was successful
        if (updateResult) {
          // Update local state for the reference
          const index = this.itemsRefCard.findIndex(
            item => item.id === complemento.id && item.title === complemento.title
          );

          if (index !== -1) {
            this.itemsRefCard[index].estado = 'Aprobado';
            this.itemsRefCard[index].original_estado = 'Aprobado';
          }

          // Show success notification
          this.$notify({
            title: 'Estado actualizado',
            text: 'Estado de la referencia actualizado correctamente.',
            color: '#2E7D32',
            timeout: 3000,
          });

          // Reset modal state
          this.modalComplementoAprobado = false;
          this.modalComplementoAprobadoData = null;
          this.comentario = '';

          // Trigger a refresh of the component data
          await this.main();
        }
      } catch (error) {
        console.error('Error al aprobar referencia:', error);

        // Show error notification
        this.$notify({
          title: 'Error',
          text: 'Hubo un error al actualizar el estado. Por favor, intente nuevamente.',
          color: '#F44336',
          timeout: 3000,
        });

        // Reset the estado to original state in case of error
        const index = this.itemsRefCard.findIndex(
          item => item.id === complemento.id && item.title === complemento.title
        );

        if (index !== -1) {
          this.itemsRefCard[index].estado = complemento.original_estado;
        }
      } finally {
        this.bloquear = false;
        EventBus.$emit('ejecutar-main');
      }
    },
    fnActualizarEstadoComplemento(complemento, index) {
      /** ACTUALIZACION DIRECTA A LA BASE DE DATOS POR ESTADOS APROBADO O PENDIENTE */
      if (complemento.estado == 'Aprobado') {
        if (this.router_path_filtro && this.router_path_filtro == 'Pendiente') {

          this.modalComplementoAprobado = true;
          this.modalComplementoAprobadoData = complemento;
          this.modalComplementoAprobadoIndex = index;

          let vm = this;
          setTimeout(() => {
            vm.$refs.motivorechazocomentario.focus();
          }, 150);

        } else {
          this.aprobadoComplemento(complemento);
        }


      } else if (complemento.estado == 'Rechazado') {
        /**VERIFICACION DE ACTUALIZACION POR ESTADO RECHAZADO */
        this.modalComplementoRechazado = true;
        this.modalComplementoRechazadoData = complemento;
        this.modalComplementoRechazadoIndex = index;
        let vm = this;
        setTimeout(() => {
          vm.$refs.motivorechazocomentario.focus();
        }, 150);


      } else if (complemento.estado == 'Pendiente') {
        /**VERIFICACION DE ACTUALIZACION POR ESTADO RECHAZADO */
        this.modalComplementoPendiente = true;
        this.modalComplementoPendienteData = complemento;
        this.modalComplementoPendienteIndex = index;
        let vm = this;
        setTimeout(() => {
          vm.$refs.motivorechazocomentario.focus();
        }, 150);
      }
    },
    async rechazarComplemento(complemento) {
      this.bloquear = true;
      try {
        await this.createRevisionRechazarReferencia({
          complemento: {
            ...complemento,
            original_estado: complemento.original_estado
          },
          currentUser: this.currentUser,
          detalleEvaluacion: this.detalleEvaluacion,
          comentario: this.comentario,
          perfil: 'fiador'  // Especificamos perfil fiador
        });

        this.$notify({
          title: 'Referencia rechazada',
          text: 'Estado de la referencia actualizado.',
          color: '#2E7D32',
          timeout: 3000,
        });

        this.modalComplementoRechazado = false;
        this.modalComplementoRechazadoData = null;
        this.comentario = null;

      } catch (error) {
        console.log(error);
        this.$notify({
          title: 'Error',
          text: error.message,
          color: '#F44336',
          timeout: 3000,
        });
      } finally {
        this.bloquear = false;
        EventBus.$emit('ejecutar-main');
      }
    },
    async pendienteComplemento(complemento) {
      if (complemento.original_estado == 'Rechazado') {

        this.$notify({
          title: 'Error al enviar como pendiente.',
          text: 'La revisión se ha marcado como rechazada.',
          color: '#F44336',
          timeout: 3000,
        });
        return; // Detiene completamente la ejecución de la función al existir un rechazo
      }
      this.bloquear = true;
      const payload = {
        [complemento.tbl_attribute]: 'Pendiente',
      };
      /** */
      let apiFunction = this.patchReferencias;
      /** */

      await apiFunction([complemento.id, payload]).then(async (r) => {
        console.log('complemento actualizado', r);
      });

      await this.createPendientes({
        gestion_id: this.detalleEvaluacion.id,
        perfil_de_usuario: 'fiador',
        pendiente_tipo: 'referencias',
        complemento_id: complemento.id,
        status_tbl_attribute: complemento.tbl_attribute,
        complemento_nombre: complemento.complemento_nombre,
        pendiente_comentario: this.comentario,

        CREADO_POR_USUARIO: this.currentUser.usuario,
        CREADO_POR_USUARIO_NOMBRE: this.currentUser.nombre,
        CREADO_POR_USUARIO_ID: this.currentUser.id,

        // pendiente_fecha: moment()
        //   .utc()
        //   .format('YYYY-MM-DDTHH:mm:ss.SSSS+00:00'),
      }).then(() => {
        this.snackbar = true;
        this.modalComplementoPendiente = false;
        this.modalComplementoPendienteData = null;
        this.comentario = null;
        this.bloquear = false;
        EventBus.$emit('ejecutar-main');
      });
    },
    cancelar() {
      /**
       * reset estado a default value
       */
      if (this.modalComplementoRechazadoData) {
        this.itemsRefCard[this.modalComplementoRechazadoIndex].estado =
          this.modalComplementoRechazadoData.original_estado;
      }

      if (this.modalComplementoPendienteData) {
        this.itemsRefCard[this.modalComplementoPendienteIndex].estado =
          this.modalComplementoPendienteData.original_estado;
      }

      if (this.modalComplementoAprobadoData) {
        this.itemsRefCard[this.modalComplementoAprobadoIndex].estado =
          this.modalComplementoAprobadoData.original_estado;
      }
      /** */
      this.modalComplementoRechazado = false;
      this.modalComplementoRechazadoData = null;
      this.modalComplementoRechazadoIndex = null;
      /** */
      this.modalComplementoPendiente = false;
      this.modalComplementoPendienteData = null;
      this.modalComplementoPendienteIndex = null;
      /** */
      this.modalComplementoAprobado = false;
      this.modalComplementoAprobadoData = null;
      this.modalComplementoAprobadoIndex = null;

      this.comentario = null;
    },
    //
    async main() {
      /**conulsta datos en base de datos */
      if (
        this.detalleEvaluacion &&
        this.detalleEvaluacion.fiador_titular_referencia_id
      ) {
        await this.getReferencias(
          this.detalleEvaluacion.fiador_titular_referencia_id
        ).then((r) => {
          this.itemsRefCard[0].id = r.id;
          this.itemsRefCard[0].nombre = r.nombre;
          this.itemsRefCard[0].telefono = r.telefono;
          this.itemsRefCard[0].parentesco = r.parentesco;
          this.itemsRefCard[0].estado = r.estado;
          this.itemsRefCard[0].original_estado = r.estado;
          this.itemsRefCard[0].ultima_actualizacion_usuario = r.ultima_modificacion_por_usuario_nombre;
          this.itemsRefCard[0].ultima_actualizacion_fecha = r.updatedAt;
        });
      }
      /************* */
      if (
        this.detalleEvaluacion &&
        this.detalleEvaluacion.fiador_familiar_1_referencia_id
      ) {
        await this.getReferencias(
          this.detalleEvaluacion.fiador_familiar_1_referencia_id
        ).then((r) => {
          this.itemsRefCard[1].id = r.id;
          this.itemsRefCard[1].nombre = r.nombre;
          this.itemsRefCard[1].telefono = r.telefono;
          this.itemsRefCard[1].parentesco = r.parentesco;
          this.itemsRefCard[1].estado = r.estado;
          this.itemsRefCard[1].original_estado = r.estado;
          this.itemsRefCard[1].ultima_actualizacion_usuario = r.ultima_modificacion_por_usuario_nombre;
          this.itemsRefCard[1].ultima_actualizacion_fecha = r.updatedAt;
        });
      }
      /************* */
      if (
        this.detalleEvaluacion &&
        this.detalleEvaluacion.fiador_familiar_2_referencia_id
      ) {
        await this.getReferencias(
          this.detalleEvaluacion.fiador_familiar_2_referencia_id
        ).then((r) => {
          this.itemsRefCard[2].id = r.id;
          this.itemsRefCard[2].nombre = r.nombre;
          this.itemsRefCard[2].telefono = r.telefono;
          this.itemsRefCard[2].parentesco = r.parentesco;
          this.itemsRefCard[2].estado = r.estado;
          this.itemsRefCard[2].original_estado = r.estado;
          this.itemsRefCard[2].ultima_actualizacion_usuario = r.ultima_modificacion_por_usuario_nombre;
          this.itemsRefCard[2].ultima_actualizacion_fecha = r.updatedAt;
        });
      }
      /************* */

      /************* */
      if (
        this.detalleEvaluacion &&
        this.detalleEvaluacion.fiador_personal_1_referencia_id
      ) {
        await this.getReferencias(
          this.detalleEvaluacion.fiador_personal_1_referencia_id
        ).then((r) => {
          this.itemsRefCard[3].id = r.id;
          this.itemsRefCard[3].nombre = r.nombre;
          this.itemsRefCard[3].telefono = r.telefono;
          this.itemsRefCard[3].parentesco = r.parentesco;
          this.itemsRefCard[3].estado = r.estado;
          this.itemsRefCard[3].original_estado = r.estado;
          this.itemsRefCard[3].ultima_actualizacion_usuario = r.ultima_modificacion_por_usuario_nombre;
          this.itemsRefCard[3].ultima_actualizacion_fecha = r.updatedAt;
        });
      }
      /************* */
      if (
        this.detalleEvaluacion &&
        this.detalleEvaluacion.fiador_personal_2_referencia_id
      ) {
        await this.getReferencias(
          this.detalleEvaluacion.fiador_personal_2_referencia_id
        ).then((r) => {
          this.itemsRefCard[4].id = r.id;
          this.itemsRefCard[4].nombre = r.nombre;
          this.itemsRefCard[4].telefono = r.telefono;
          this.itemsRefCard[4].parentesco = r.parentesco;
          this.itemsRefCard[4].estado = r.estado;
          this.itemsRefCard[4].original_estado = r.estado;
          this.itemsRefCard[4].ultima_actualizacion_usuario = r.ultima_modificacion_por_usuario_nombre;
          this.itemsRefCard[4].ultima_actualizacion_fecha = r.updatedAt;
        });
      }
      /************* */
      /**conulsta datos en base de datos, fin */

      let vm = this;
      await setTimeout(() => {
        vm.still_loading = false;
      }, 200);
    },
    //
    fn_check_if_pendiente_debe_actualizarse(complemento) {
      console.log(complemento);
      this.findPendientes({
        query: {
          STATUS: 1,
          gestion_id: this.detalleEvaluacion.id,
          complemento_id: complemento.id
        }
      }).then(result => {
        // Verifica si existe algún pendiente
        if (result.data && result.data.length > 0) {
          const pendiente = result.data[0]; // Supongamos que solo necesitas el primero

          // Realiza el patch con el id del pendiente encontrado
          this.patchPendientes([pendiente.id, { STATUS: 2 }]).then(() => {
            console.error('Se actualizo pendiente');
          });
        } else {
          console.error('No se encontró ningún pendiente, al aprobar el complemento');
        }
      }).catch(error => {
        console.error('Error al buscar el pendiente:', error);
      });
    },
    //
  },
  computed: {
    flag_gestion_terminada() {
      if (this.detalleEvaluacion.flag_precalificacion_concluidas == 1) {
        return true
      } else if (this.detalleEvaluacion.flag_precalificacion_cancelada == 1) {
        return true
      } else if (this.detalleEvaluacion.flag_precalificacion_eliminada == 1) {
        return true
      } else {
        return false
      }
    },
    VUE_APP_FEATHERS_SERVER() {
      return process.env.VUE_APP_FEATHERS_SERVER;
    },
    comentarioValido() {
      return !!this.comentario;
    },
    currentUser() {
      return this.$store.state.auth.payload.usuario;
    },
    router_path_filtro() {
      if (this.$route.params.filtro) return this.$route.params.filtro;
      else return null;
    },
  },
  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.main();
    }, 200);

    /**actualizar datos al actualizar o crear compleentos de gestion */
    const {
      Contratos,
      DocumentosDeIdentificacion,
      Recibos,
      FotografiasDeCasa,
      Referencias,
      RecibosComerciales
    } = this.$FeathersVuex.api;
    Contratos.on('patched', () => {
      this.main();
    });
    DocumentosDeIdentificacion.on('patched', () => {
      this.main();
    });
    Recibos.on('patched', () => {
      this.main();
    });
    FotografiasDeCasa.on('patched', () => {
      this.main();
    });
    Referencias.on('patched', () => {
      this.main();
    });
    RecibosComerciales.on('patched', () => {
      this.main();
    });
    /**actualizar datos al actualizar o crear compleentos de gestion, fin */
  },
};
</script>

<style scoped>
table {
  width: 100%;
  border-collapse: collapse;
}

th,
td {
  padding: 3px;
}
</style>
